import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
	name: 'shipmentdetails',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		DatePicker
		// VueCtkDateTimePicker
	},
	props: ['hubid'],
	data() {
		return {
			showShipmentDetailsModal:false,
			manifestName:'',
			ManifestDatalist:[
				{
	        value: 1,
	        text: "APIManifest"
	      }, {
	        value: 2,
	        text: "InBound"
	      },{
	        value: 3,
	        text: "SupplierManifest"
	      },
				{
					value: 4,
					text: "SecondaryInScan"
				},
				{
					value: 5,
					text: "FS"
				}
			],
			shipmentno: '',
			destinationhublist: [],
			manifestData:{
				text: '',
				value: ''
			},

			hubLoading: '',
			SQSName:'',
			shipmentDetailsList: [],
			username: '',
			useremail: '',
			uasertype: '',
			hubid: '',
			fromdate: '',
			todate: '',
			totalShipments:'',
			isLoading:false
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.uasertype = userdetail[0].utype;
		this.username = userdetail[0].FirstName;
		this.useremail = userdetail[0].email
	},
	methods: {
		SelectManifestData(obj) {
      this.manifestData = obj
      this.manifestName = obj.text
      //this.ManifestId=obj.value
    },
		dateFormat(date) {
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		getShipmentList() {
			this.showShipmentDetailsModal = false,
			this.isLoading=true,
			this.input = ({
				"DataForm":this.manifestName,
				"FromDate":this.dateFormat(this.fromdate),
				"ToDate":this.dateFormat(this.todate),
				"sorterHubLocation":this.hubid
			})
			axios({
					method: 'POST',
				 	url: apiUrl.api_url_hubops + 'pushShipmentDataForFalconSorter',
					data: this.input,
					headers: {
						'Authorization': "authkey xB84JJ89Hd25"
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.isLoading=false,
						this.shipmentDetailsList = result.data.ResponseData;
						this.totalShipments=this.shipmentDetailsList.length
						this.showShipmentDetailsModal=true;
						this.$alertify.success(result.data.ReturnMessage)

					} else {
						this.isLoading=false,
						this.pageCount = 0
						this.shipmentDetailsList = [];
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoading = false
					console.error(error)

				})
		},

		resetflt() {
			this.isLoading=false,
			this.shipmentDetailsList = [],
		  this.fromdate = '',
		  this.todate = '',
		  this.shipmentno = '',
		  this.manifestName = '',
		  this.manifestData = {
		    text: '',
		    value: '',
		  },
		  this.showShipmentDetailsModal = false,
		  this.fromdate = '',
		  this.todate = '',
		  this.$validator.reset(),
			this.totalShipments=''
		},
		onSubmitflt: function() {

			var self = this
			this.$validator.validateAll().then((result) => {
			 if (!result) {
					return false
				} else {
					this.getShipmentList();
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/FalconSorter/pushShipmentDataNew/pushShipmentDataNew.js